import React from 'react';

const Location = () => {
  return (
    <div className="card" id="location">
      <h2>Location</h2>
      
      <div style={{
        marginBottom: '20px'
      }}>
        <div style={{
          fontSize: '16px',
          fontWeight: '500',
          color: '#2c3e50',
          marginBottom: '8px'
        }}>
          Hollywood Lakes
        </div>
        <div style={{
          fontSize: '15px',
          color: '#555',
          marginBottom: '12px'
        }}>
          Hollywood, Florida
        </div>
        <div style={{
          fontSize: '14px',
          color: '#666',
          lineHeight: '1.6'
        }}>
          Located in Hollywood Lakes, this vacation home is 0.8 mi (1.3 km) from Hollywood Beach Golf Club and 2 mi (3.2 km) from Hollywood Beach. The ArtsPark at Young Circle and Hollywood Boulevard Historic Business District are also within 2 mi (3 km).
        </div>
      </div>

      {/* Static Map */}
      <div style={{
        width: '100%',
        height: '400px',
        borderRadius: '12px',
        overflow: 'hidden',
        border: '1px solid #e5e7eb'
      }}>
        <img 
          src="/static-map.png"
          alt="Map showing property location in Hollywood Lakes near Johnson St"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
      </div>
    </div>
  );
};

export default Location;